import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchPracticeTests,
  fetchPracticeAssessments,
  fetchPracticeAssessmentResult,
} from '../../store/actions/PracticeTestActions';
import { fetchTestSettings } from '../../store/actions/AssessmentActions';
import { useHistory } from 'react-router-dom';
import PracticeTestsComponent from '../../components/PracticeTests/PracticeTestsComponent';

const PracticeTestsContainer = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { practiceTests, practiceAssessments, loading, error } = useSelector(
    state => state.practiceTest,
  );

  useEffect(() => {
    dispatch(fetchPracticeTests());
    dispatch(fetchPracticeAssessments());
  }, [dispatch]);

  const handleTakeTest = testId => {
    dispatch(
      fetchTestSettings(testId, () => {
        // Navigate to practice test instructions page after fetching test settings
        history.push(`/practices-instruction/${testId}`);
      }),
    );
  };

  // Update practice tests with attempts count based on practice assessments
  const testsWithAttempts =
    practiceTests.results?.map(test => {
      const attempts = practiceAssessments.results?.filter(
        assessment => assessment.test_id === test.id,
      ).length;
      return {
        ...test,
        attempts: attempts || 0,
      };
    }) || [];

  return (
    <div style={{ backgroundColor: '#f0f3f7' }}>
      <PracticeTestsComponent
        practiceTests={testsWithAttempts}
        loading={loading}
        error={error}
        onTakeTest={handleTakeTest}
      />
    </div>
  );
};

export default PracticeTestsContainer;
